<template>
  <div class="game-replay-dialog">
    <el-dialog
      :title="isEdit ? '编辑复盘' : '创建复盘'"
      :visible.sync="visible"
      width="80%"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleDialogClose"
      :z-index="2000"
      custom-class="replay-nav-dialog">
      
      <!-- 固定的赛事信息区域 -->
      <div class="fixed-game-info">
        <span class="info-value">{{ gameInfo.game_name }}</span>
        <span class="separator">|</span>
        <span class="info-value">{{ gameInfo.game_type }}</span>
        <span class="separator">|</span>
        <span class="info-value">{{ gameInfo.game_level }}</span>
        </div>

      <!-- 导航+内容区域 -->
      <div class="replay-content-wrapper">
        <!-- 左侧导航 -->
        <div class="replay-nav">
          <div 
            v-for="item in navItems" 
            :key="item.index"
            class="nav-item"
            :class="getNavClass(item.index)"
            @click="handleTabChange(item.index)">
            <i :class="getNavIcon(item.index)" class="nav-icon"></i>
            <span class="nav-label">{{ item.label }}</span>
          </div>
        </div>
        
        <!-- 右侧内容区域 -->
        <div class="replay-editor-area">
          <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <!-- 全局复盘编辑区 -->
            <div v-show="currentTab === 0" class="global-replay">
              <el-form-item prop="global_replay" required label-width="0">
            <mavon-editor
              v-model="form.global_replay"
              :toolbars="markdownToolbars"
              :boxShadow="false"
              :placeholder="'请输入赛事的整体复盘内容，包括总体表现、经验总结等'"
              :ishljs="true"
              :codeStyle="'github'"
              :subfield="true"
              :defaultOpen="''"
                  height="400px"
              class="global-replay-editor"
            />
          </el-form-item>
        </div>

            <!-- 题目复盘编辑区 -->
            <div 
              v-for="(question, index) in form.questions" 
              :key="question.question_code"
              v-show="currentTab === index + 1"
              class="question-section">
              
              <!-- 题目信息 -->
          <div class="question-header">
            <div class="question-info">
                  <div class="info-line">
                    <span class="seq">{{ question.question_seq }}</span>
                    <span class="name">{{ question.question_name }}</span>
                    <span class="label">分数：</span>
                    <span class="value" :style="{ color: getScoreColor(question.question_score), fontWeight: '600' }">{{ question.question_score }}</span>
                    <span class="label">订正分数：</span>
                    <span class="value" :style="{ color: getScoreColor(question.question_score_fix), fontWeight: '600' }">{{ question.question_score_fix }}</span>
                    <span class="label">难度：</span>
                    <el-tag 
                      size="small"
                      :style="getQuestionLevelStyle(question.question_level)">
                      {{ getQuestionLevelLabel(question.question_level) }}
                    </el-tag>
                    
                    <div v-if="question.tags && question.tags.length" class="tags-inline">
                      <span class="label">标签：</span>
                  <el-tag
                    v-for="tag in question.tags"
                    :key="tag.tag_code"
                        :class="getTagColorClass(tag.tag_code)"
                        class="solid-tag"
                        size="small">
                    {{ tag.tag_name }}
                  </el-tag>
                </div>
              </div>
            </div>
          </div>

              <!-- 题目选项 - 水平单行布局 -->
              <div class="question-options">
                <span class="option-label">
                  <span class="label-text">错误类型</span>
                  <span class="required-mark">*</span>
                </span>
              <el-form-item 
                :prop="'questions.' + index + '.error_codes'"
                :required="question.question_score !== 100"
                  label-width="0"
                  :show-message="false"
                  style="margin-bottom: 0;">
                <el-select 
                  v-model="form.questions[index].error_codes" 
                  multiple
                  filterable
                    placeholder="请选择"
                  :disabled="form.questions[index].question_score === 100"
                    style="width: 220px;">
                  <el-option 
                    v-for="err in allErrors" 
                    :key="err.error_code" 
                    :label="err.error_name" 
                    :value="err.error_code">
                    <el-tooltip :content="err.error_note" placement="right" effect="dark">
                      <span>
                        <el-tag :style="getErrorOutlineStyle(err.error_code)" size="small" style="margin-right: 8px;">
                          <i class="el-icon-warning" style="margin-right: 4px;"></i>{{ err.error_name }}
                        </el-tag>
                      </span>
                    </el-tooltip>
                  </el-option>
                </el-select>
              </el-form-item>
                
                <span class="option-label">
                  <span class="label-text">符合预期</span>
                  <span class="required-mark">*</span>
                </span>
              <el-form-item 
                :prop="'questions.' + index + '.is_expect'"
                required
                  label-width="0"
                  :show-message="false"
                  style="margin-bottom: 0;">
                  <el-select v-model="form.questions[index].is_expect" placeholder="请选择" style="width: 120px;">
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
                
                <span class="option-label">
                  <span class="label-text">补知识点</span>
                  <span class="required-mark">*</span>
                </span>
              <el-form-item 
                :prop="'questions.' + index + '.is_plan'"
                required
                  label-width="0"
                  :show-message="false"
                  style="margin-bottom: 0;">
                  <el-select 
                    v-model="form.questions[index].is_plan" 
                    placeholder="请选择" 
                    style="width: 120px;"
                    @change="(val) => handlePlanChange(val, index)">
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                  </el-select>
                </el-form-item>
                
                <div v-if="form.questions[index].is_plan === 1 && form.questions[index].plan_name" class="plan-display">
                  <span class="plan-label">学习计划：</span>
                    <el-tag type="danger">{{ form.questions[index].plan_name }}</el-tag>
                </div>
              </div>
          
          <el-form-item 
            :prop="'questions.' + index + '.replay_info'"
                required
                label-width="0">
            <mavon-editor
              v-model="form.questions[index].replay_info"
              :toolbars="markdownToolbars"
              :boxShadow="false"
              :placeholder="'请输入复盘内容'"
              :ishljs="true"
              :codeStyle="'github'"
              :subfield="true"
              :defaultOpen="''"
                  height="300px"
              class="question-replay-editor"
            />
          </el-form-item>
        </div>
      </el-form>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleCancel">取 消</el-button>
        <el-button size="medium" type="primary" @click="handleSubmit">
          <i class="el-icon-check"></i>
          保存复盘
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="输入学习计划"
      :visible.sync="knowledgePointDialog.visible"
      width="30%"
      :append-to-body="true"
      :before-close="handleKnowledgePointCancel">
      <el-form>
        <el-form-item label="计划名称" label-width="70px">
          <el-input 
            v-model="knowledgePointDialog.knowledgePoint"
            placeholder="请输入学习计划名称"
            @keyup.enter.native="handleKnowledgePointSubmit">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleKnowledgePointCancel">取 消</el-button>
        <el-button type="primary" @click="handleKnowledgePointSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { saveGameReplay } from '@/api/game'
import { getQuestions } from '@/api/question'
import { getErrorCodes } from '@/api/error'
import { QUESTION_LEVELS, getQuestionLevelStyle } from '@/constants/questionLevel'
import { getErrorTagInlineStyle, getErrorOutlineStyle } from '@/constants/errorTypes'
import { mavonEditor } from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

export default {
  name: 'GameReplay',
  components: {
    mavonEditor
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    gameInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isEdit: false,
      questions: [],
      allErrors: [], // 错误类型列表
      currentTab: 0, // 当前选中的tab，0表示全局，1表示T1，2表示T2...
      form: {
        global_replay: '',
        questions: []
      },
      rules: {
        global_replay: [
          { required: true, message: '请输入全局复盘内容', trigger: 'blur' }
        ],
        'questions.*.is_expect': [
          { required: true, message: '请选择是否符合预期', trigger: 'change' }
        ],
        'questions.*.is_plan': [
          { required: true, message: '请选择是否补充知识点', trigger: 'change' }
        ],
        'questions.*.replay_info': [
          { required: true, message: '请输入复盘内容', trigger: 'blur' }
        ],
        'questions.*.error_codes': [
          { 
            validator: (rule, value, callback) => {
              const questionIndex = parseInt(rule.field.split('.')[1])
              const question = this.form.questions[questionIndex]
              
              // 如果得分是100分，则不需要选择错误类型
              if (question && question.question_score === 100) {
                callback()
                return
              }
              
              // 如果得分不是100分，则必须选择错误类型
              if (!value || value.length === 0) {
                callback(new Error('请选择错误类型'))
              } else {
                callback()
              }
            }, 
            trigger: 'change' 
          }
        ]
      },
      knowledgePointDialog: {
        visible: false,
        currentIndex: -1,
        knowledgePoint: ''
      },
      markdownToolbars: {
        bold: true,
        italic: true,
        header: true,
        underline: true,
        strikethrough: true,
        mark: true,
        superscript: true,
        subscript: true,
        quote: true,
        ol: true,
        ul: true,
        link: true,
        imagelink: true,
        code: true,
        table: true,
        fullscreen: true,
        readmodel: true,
        htmlcode: false,
        help: true,
        undo: true,
        redo: true,
        trash: true,
        navigation: false,
        alignleft: true,
        aligncenter: true,
        alignright: true,
        subfield: true,
        preview: true
      },
      markdownToolbarsSimple: {
        bold: true,
        italic: true,
        header: true,
        underline: true,
        strikethrough: true,
        quote: true,
        ol: true,
        ul: true,
        link: true,
        code: true,
        table: true,
        undo: true,
        redo: true,
        trash: true,
        preview: true
      }
    }
  },
  computed: {
    // 导航项列表
    navItems() {
      const items = []
      // 先添加题目
      this.form.questions.forEach((q, idx) => {
        items.push({
          label: `${q.question_seq}`,  // 去掉多余的T
          index: idx + 1,
          isGlobal: false,
          question: q
        })
      })
      // 全局复盘放到最后
      items.push({ label: '全局复盘', index: 0, isGlobal: true })
      return items
    },
    // 当前选中的题目（如果是全局则返回null）
    currentQuestion() {
      if (this.currentTab === 0) return null
      return this.form.questions[this.currentTab - 1]
    },
    // 判断某个tab是否完成
    isTabCompleted() {
      return (tabIndex) => {
        if (tabIndex === 0) {
          // 全局复盘：有内容即可
          return this.form.global_replay && this.form.global_replay.trim().length > 0
        } else {
          // 题目复盘：检查所有必填项
          const question = this.form.questions[tabIndex - 1]
          if (!question) return false
          
          const hasReplayInfo = question.replay_info && question.replay_info.trim().length > 0
          const hasExpect = question.is_expect !== '' && question.is_expect !== undefined && question.is_expect !== null
          const hasPlan = question.is_plan !== '' && question.is_plan !== undefined && question.is_plan !== null
          
          // 如果不是满分，还需要检查错误类型
          if (question.question_score !== 100) {
            const hasErrorCodes = question.error_codes && question.error_codes.length > 0
            return hasReplayInfo && hasExpect && hasPlan && hasErrorCodes
          }
          
          return hasReplayInfo && hasExpect && hasPlan
        }
      }
    }
  },
  watch: {
    visible: {
      async handler(val) {
        if (val) {
          await this.fetchErrorCodes()
          await this.fetchQuestions()
          // currentTab 在 fetchQuestions 中设置
          
          // 延迟调整padding，确保编辑器完全渲染
          setTimeout(() => {
            this.adjustEditorPadding()
          }, 500)
        }
      },
      immediate: true
    },
    currentTab() {
      // 切换tab时也调整padding
      setTimeout(() => {
        this.adjustEditorPadding()
      }, 300)
    }
  },
  methods: {
    getQuestionLevelStyle,
    getErrorTagInlineStyle,
    getErrorOutlineStyle,
    getQuestionLevelLabel(level) {
      const levelConfig = QUESTION_LEVELS.find(item => item.value === level) || QUESTION_LEVELS[0]
      return levelConfig.label
    },
    getScoreClass(score) {
      if (score === 100) return 'score-perfect'
      if (score >= 60) return 'score-good'
      return 'score-bad'
    },
    // 获取分数颜色（0-100从红到绿）
    getScoreColor(score) {
      if (score === undefined || score === null) return '#606266';
      const percentage = (score / 100) * 100;
      if (percentage >= 100) return '#237804'; // 深绿色
      if (percentage >= 75) return '#52C41A'; // 黄绿色
      if (percentage >= 50) return '#F7BA2A'; // 黄色
      if (percentage >= 25) return '#E6A23C'; // 橙色
      return '#F56C6C'; // 红色
    },
    // 获取标签颜色类
    getTagColorClass(tagCode) {
      const colors = [
        'tag-color-1', 'tag-color-2', 'tag-color-3', 'tag-color-4', 'tag-color-5',
        'tag-color-6', 'tag-color-7', 'tag-color-8', 'tag-color-9', 'tag-color-10'
      ]
      const index = parseInt(tagCode.split('_')[1], 36) % colors.length
      return colors[index]
    },
    // 切换tab
    handleTabChange(tabIndex) {
      this.currentTab = tabIndex
    },
    // 获取导航项状态图标
    getNavIcon(tabIndex) {
      if (this.isTabCompleted(tabIndex)) {
        return 'el-icon-check'
      }
      return 'el-icon-circle-check'
    },
    // 获取导航项状态类
    getNavClass(tabIndex) {
      if (this.currentTab === tabIndex) return 'active'
      if (this.isTabCompleted(tabIndex)) return 'completed'
      return 'incomplete'
    },
    async fetchQuestions() {
      try {
        const res = await getQuestions(this.gameInfo.game_code)
        if (res.code === 200) {
          this.questions = res.data || []
          this.initForm()
          // 如果有题目，默认显示第一题；否则显示全局
          this.currentTab = this.questions.length > 0 ? 1 : 0
        } else {
          this.$message.error(res.message || '获取题目列表失败')
        }
      } catch (error) {
        console.error('获取题目列表失败:', error)
        this.$message.error('获取题目列表失败')
      }
    },
    async fetchErrorCodes() {
      try {
        const res = await getErrorCodes()
        if (res.code === 200) {
          this.allErrors = res.data || []
        }
      } catch (error) {
        console.error('获取错误类型列表失败:', error)
      }
    },
    initForm() {
      this.form = {
        global_replay: '',
        questions: this.questions.map(question => {
          // 处理错误类型数据，确保是数组格式
          // 字段名可能是 errors 或 error_codes
          let errorCodes = []
          const errorData = question.errors || question.error_codes
          
          if (errorData) {
            if (Array.isArray(errorData)) {
              errorCodes = errorData
            } else if (typeof errorData === 'string') {
              try {
                const parsed = JSON.parse(errorData)
                errorCodes = Array.isArray(parsed) ? parsed : []
              } catch (e) {
                console.warn('解析错误类型失败:', errorData)
                errorCodes = []
              }
            }
          }
          
          // 如果是对象数组 [{error_code: 'xxx', error_name: 'xxx'}]，提取error_code
          if (errorCodes.length > 0 && typeof errorCodes[0] === 'object') {
            errorCodes = errorCodes.map(err => err.error_code || err)
          }
          
          return {
          question_code: question.question_code,
          question_seq: question.question_seq,
          question_name: question.question_name,
          question_score: question.question_score,
          question_score_fix: question.question_score_fix,
          question_level: question.question_level,
          tags: question.tags || [],
            error_codes: errorCodes, // 使用处理后的错误类型数组
            is_expect: '',  // 修改为空，必须用户选择
            is_plan: '',    // 修改为空，必须用户选择
          replay_info: '',
          plan_name: ''
          }
        })
      }
    },
    handleDialogClose(done) {
      if (this.hasUnsavedContent()) {
        this.$confirm('有未保存的内容，确认关闭吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$refs.form?.resetFields()
          this.$emit('update:visible', false)
          done()
        }).catch(() => {
          // 用户点击取消，不关闭弹窗
        })
      } else {
        this.$refs.form?.resetFields()
        this.$emit('update:visible', false)
        done()
      }
    },
    handleCancel() {
      if (this.hasUnsavedContent()) {
        this.$confirm('有未保存的内容，确认关闭吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$refs.form?.resetFields()
          this.$emit('update:visible', false)
        }).catch(() => {
          // 用户点击取消，不关闭弹窗
        })
      } else {
        this.$refs.form?.resetFields()
        this.$emit('update:visible', false)
      }
    },
    handlePlanChange(val, index) {
      if (val === 1) {
        this.knowledgePointDialog.currentIndex = index
        this.knowledgePointDialog.knowledgePoint = this.form.questions[index].plan_name || ''
        this.knowledgePointDialog.visible = true
      } else {
        this.form.questions[index].plan_name = ''
      }
    },
    handleKnowledgePointSubmit() {
      if (!this.knowledgePointDialog.knowledgePoint.trim()) {
        this.$message.warning('请输入学习计划名称')
        return
      }
      
      const index = this.knowledgePointDialog.currentIndex
      if (index !== null) {
        this.form.questions[index].plan_name = this.knowledgePointDialog.knowledgePoint
      }
      
      this.knowledgePointDialog.visible = false
      this.knowledgePointDialog.currentIndex = null
      this.knowledgePointDialog.knowledgePoint = ''
    },
    handleKnowledgePointCancel() {
      const index = this.knowledgePointDialog.currentIndex
      if (index !== null) {
        this.form.questions[index].is_plan = 0
        this.form.questions[index].plan_name = ''
      }
      
      this.knowledgePointDialog.visible = false
      this.knowledgePointDialog.currentIndex = null
      this.knowledgePointDialog.knowledgePoint = ''
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        
        const submitData = {
          game_code: this.gameInfo.game_code,
          global_replay: this.form.global_replay.trim(),
          questions: this.form.questions.map(question => ({
            question_code: question.question_code,
            is_expect: question.is_expect,
            is_plan: question.is_plan,
            replay_info: question.replay_info.trim(),
            plan_name: question.plan_name || '',
            error_codes: question.error_codes || []
          }))
        }

        console.log('提交的数据:', submitData)

        const response = await saveGameReplay(submitData)

        if (response.code === 200) {
          this.$message.success('保存成功')
          this.$refs.form?.resetFields()
          this.$emit('update:visible', false)
          this.$emit('success')
        } else {
          this.$message.error(response.message || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        if (error.message) {
          this.$message.error(error.message)
        } else {
          this.$message.error('表单验证失败，请检查必填项')
        }
      }
    },
    hasUnsavedContent() {
      return this.form.global_replay.trim() !== '' || 
        this.form.questions.some(q => 
          (q.is_expect !== '' && q.is_expect !== undefined && q.is_expect !== null) || 
          (q.is_plan !== '' && q.is_plan !== undefined && q.is_plan !== null) || 
          q.replay_info.trim() !== '' ||
          q.plan_name !== '' ||
          (q.error_codes && q.error_codes.length > 0)
        )
    },
    handleClose() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    
    handleEscClose(e) {
      if (e.keyCode === 27) {
        this.handleClose()
      }
    },
    // 修改编辑器padding和段落间距
    adjustEditorPadding() {
      this.$nextTick(() => {
        setTimeout(() => {
          // 查找所有编辑区域的 content-input-wrapper
          const contentWrappers = document.querySelectorAll('.replay-nav-dialog .content-input-wrapper')
          console.log('找到content-input-wrapper数量:', contentWrappers.length)
          contentWrappers.forEach(wrapper => {
            wrapper.style.padding = '12px'
            wrapper.style.setProperty('padding', '12px', 'important')
          })
          
          // 查找所有显示区域的 v-note-show
          const showAreas = document.querySelectorAll('.replay-nav-dialog .v-note-show')
          console.log('找到v-note-show数量:', showAreas.length)
          showAreas.forEach(area => {
            area.style.padding = '12px'
            area.style.setProperty('padding', '12px', 'important')
          })
          
          // 修改显示区域的段落间距
          const paragraphs = document.querySelectorAll('.replay-nav-dialog .v-show-content p')
          console.log('找到段落p数量:', paragraphs.length)
          paragraphs.forEach(p => {
            p.style.setProperty('margin-bottom', '8px', 'important')
          })
        }, 300)
      })
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscClose)
    this.adjustEditorPadding()
  },
  updated() {
    this.adjustEditorPadding()
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscClose)
  }
}
</script>

<style lang="scss" scoped>
.game-replay-dialog {
  // 固定的赛事信息区域 - 在最上面
  .fixed-game-info {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    padding: 14px 20px !important;
    border-bottom: 2px solid #5a67d8 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 20px !important;
    flex-shrink: 0 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
    
    .info-value {
      color: #ffffff !important;
      font-size: 16px !important;
      font-weight: 600 !important;
    }
    
    .separator {
      color: rgba(255, 255, 255, 0.6) !important;
      font-size: 16px !important;
      font-weight: 300 !important;
    }
  }
  
  // 导航+内容区域（横向布局）
  .replay-content-wrapper {
    flex: 1 !important;
    display: flex !important;
    flex-direction: row !important;
    overflow: hidden !important;
    min-height: 0 !important;
    
    // 左侧导航
    .replay-nav {
      width: 150px !important;
      flex-shrink: 0 !important;
      background: linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%) !important;
      border-right: 1px solid #dee2e6 !important;
      overflow-y: auto !important;
      padding: 12px 8px !important;
      
      &::-webkit-scrollbar {
        width: 5px;
      }
      
      &::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.02);
      }
      
      &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.15);
        border-radius: 3px;
        
        &:hover {
          background-color: rgba(0, 0, 0, 0.25);
        }
      }
      
      .nav-item {
        padding: 12px 14px;
        margin-bottom: 6px;
        cursor: pointer;
          display: flex;
          align-items: center;
        gap: 10px;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        border-radius: 6px;
        border-left: 3px solid transparent;
        position: relative;
        
        .nav-icon {
          font-size: 16px;
          flex-shrink: 0;
          transition: all 0.2s ease;
        }
        
        .nav-label {
          font-size: 14px;
          font-weight: 500;
          flex: 1;
        }
        
        // 未完成状态
        &.incomplete {
          color: #6c757d;
          background-color: transparent;
          
          .nav-icon {
            color: #adb5bd;
          }
          
          &:hover {
            background-color: rgba(255, 255, 255, 0.7);
            color: #495057;
            transform: translateX(2px);
            
            .nav-icon {
              color: #6c757d;
            }
          }
        }
        
        // 已完成状态
        &.completed {
          color: #28a745;
          background-color: transparent;
          
          .nav-icon {
            color: #28a745;
          }
          
          &:hover {
            background-color: rgba(40, 167, 69, 0.1);
            transform: translateX(2px);
          }
        }
        
        // 激活状态
        &.active {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: #ffffff;
          font-weight: 600;
          box-shadow: 0 3px 8px rgba(102, 126, 234, 0.3);
          border-left-color: transparent;
          
          .nav-icon {
            color: #ffffff;
          }
          
          .nav-label {
            font-weight: 600;
          }
          
          &:hover {
            transform: translateX(0);
            box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
          }
          
          // 激活且已完成
          &.completed {
            .nav-icon {
              color: #ffffff;
            }
          }
        }
      }
    }
    
    // 右侧编辑区域
    .replay-editor-area {
      flex: 1 !important;
      overflow-y: auto !important;
      overflow-x: hidden !important;
      padding: 24px !important;
      background-color: #ffffff !important;
      min-width: 0 !important;
      
      &::-webkit-scrollbar {
        width: 8px;
      }
      
      &::-webkit-scrollbar-track {
        background: #f8f9fa;
        border-radius: 4px;
      }
      
      &::-webkit-scrollbar-thumb {
        background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
        border-radius: 4px;
        
        &:hover {
          background: linear-gradient(180deg, #5a67d8 0%, #6a42a8 100%);
        }
      }
    }
  }
  
  .global-replay {
    ::v-deep .el-form-item {
      margin-bottom: 0;
    }
    
    ::v-deep .el-form-item__label {
      display: none !important;
    }

    ::v-deep .el-form-item__content {
      line-height: normal;
      margin-left: 0 !important;
    }
  }
  
  .question-section {
    
    .question-header {
      margin-bottom: 24px;
      padding-bottom: 18px;
      border-bottom: 2px solid #ebeef5;
      
      .question-info {
        .info-line {
      display: flex;
      align-items: center;
          flex-wrap: wrap;
          gap: 10px 18px;
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);
          padding: 14px 18px;
          border-radius: 8px;
          border: 1px solid rgba(102, 126, 234, 0.15);
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
          
          .seq {
            font-weight: 700;
            color: #667eea;
            font-size: 16px;
            background: rgba(102, 126, 234, 0.1);
            padding: 2px 8px;
            border-radius: 4px;
            margin-right: 8px;
          }
          
          .name {
            font-weight: 600;
            color: #212529;
            font-size: 15px;
          }
          
          .label {
            color: #6c757d;
            font-size: 13px;
            font-weight: 500;
          }
          
          .value {
            font-weight: 600;
            font-size: 14px;
          }
          
          .tags-inline {
      display: flex;
      align-items: center;
            flex-wrap: wrap;
            gap: 0;
            
            .label {
              margin-right: 6px;
            }
          }
        }
      }
    }
    
    ::v-deep .el-row {
      margin-bottom: 0 !important;
    }
    
    ::v-deep .el-form-item {
      margin-bottom: 20px;
    }
    
    ::v-deep .el-form-item__label {
      font-weight: 600;
      color: #495057;
    }
    
    // 题目选项区域 - 水平单行布局
    .question-options {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 12px;
      margin-bottom: 20px;
      flex-wrap: wrap;
      
      .option-label {
        display: flex;
        align-items: center;
        gap: 4px;
        white-space: nowrap;

        .label-text {
          font-size: 13px;
          font-weight: 600;
          color: #495057;
        }
        
        .required-mark {
          color: #f56c6c;
          font-size: 13px;
        }
      }
      
      .plan-display {
        display: flex;
        align-items: center;
        gap: 6px;
        
        .plan-label {
          color: #6c757d;
          font-size: 13px;
          font-weight: 500;
          white-space: nowrap;
        }
      }
      
      ::v-deep .el-form-item {
        margin-bottom: 0 !important;
        
        .el-form-item__label {
          display: none !important;
        }
        
        .el-form-item__content {
          margin-left: 0 !important;
        }
      }
    }
  }
      
  // 分数颜色由动态计算，不再需要固定class样式
  
  .dialog-footer {
        display: flex;
    justify-content: flex-end;
    gap: 12px;
    
    ::v-deep .el-button {
      padding: 10px 24px;
      border-radius: 6px;
      font-weight: 500;
      
      &--primary {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        box-shadow: 0 3px 8px rgba(102, 126, 234, 0.3);
        
        i {
          margin-right: 6px;
        }
        
        &:hover {
          background: linear-gradient(135deg, #5a67d8 0%, #6a42a8 100%);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
          transform: translateY(-1px);
        }
        
        &:active {
          transform: translateY(0);
        }
      }
    }
  }
}

.game-replay-dialog .global-replay {
  :deep(.v-note-wrapper) {
    border-radius: 8px;
    z-index: 1;
    border: 1px solid rgba(102, 126, 234, 0.2);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    overflow: hidden;

    .v-note-op {
      background: linear-gradient(to bottom, #fafbfc, #f6f8fa);
      border-bottom: 1px solid #dee2e6;
      padding: 8px 10px;
    }

    .v-note-panel {
      min-height: 200px;
    }

    .auto-textarea-input,
    .v-note-show-content {
      min-height: 150px;
      padding: 12px;
    }
  }
  
  // 使用更强的选择器覆盖mavon-editor默认样式
  :deep(.v-note-wrapper .v-note-panel .v-note-edit .content-input-wrapper) {
    padding: 12px !important;
  }
  
  :deep(.v-note-wrapper .v-note-panel .v-note-show) {
    padding: 12px !important;
  }
  
  // 设置段落间距
  :deep(.v-note-wrapper .v-note-panel .v-note-show .v-show-content) {
    p {
      margin: 0 0 8px 0 !important;
    }
  }
}

.game-replay-dialog .question-section {
  :deep(.v-note-wrapper) {
    border-radius: 8px;
    z-index: 1;
    border: 1px solid rgba(102, 126, 234, 0.2);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    overflow: hidden;

    .v-note-op {
      background: linear-gradient(to bottom, #fafbfc, #f6f8fa);
      border-bottom: 1px solid #dee2e6;
      padding: 8px 10px;
    }

    .v-note-panel {
      min-height: 150px;
    }

    .auto-textarea-input,
    .v-note-show-content {
      min-height: 120px;
      padding: 12px;
      
      p {
        margin-bottom: 8px !important;
      }
    }
  }
  
  // 使用更强的选择器覆盖mavon-editor默认样式
  :deep(.v-note-wrapper .v-note-panel .v-note-edit .content-input-wrapper) {
    padding: 12px !important;
  }
  
  :deep(.v-note-wrapper .v-note-panel .v-note-show) {
    padding: 12px !important;
  }
  
  // 设置段落间距
  :deep(.v-note-wrapper .v-note-panel .v-note-show .v-show-content) {
    p {
      margin: 0 0 8px 0 !important;
    }
  }
}

:deep(.v-note-wrapper) {
  z-index: 1 !important;
  
  // 全屏模式时提升层级，确保在对话框之上
  &.fullscreen {
    z-index: 9999 !important;
    background-color: #fff !important;
    
    // 确保预览区域有白色背景
    .v-note-panel {
      background-color: #fff !important;
      
      .v-note-edit,
      .v-note-show {
        background-color: #fff !important;
      }
      
      .v-show-content,
      .v-note-show-content {
        background-color: #fff !important;
      }
    }
  }
  
  .v-note-navigation-wrapper {
    display: none !important;
  }
  
  // 通用编辑器工具栏样式优化
  .v-note-op {
    display: flex !important;
    flex-wrap: nowrap !important;
    overflow-x: auto !important;
    
    .v-left-item {
      flex: 1 !important;
      max-width: 92% !important;
      min-width: 0 !important;
      display: flex !important;
      flex-wrap: wrap !important;
    }
    
    .v-right-item {
      flex: 0 0 auto !important;
      max-width: 8% !important;
      min-width: fit-content !important;
      display: flex !important;
      flex-wrap: wrap !important;
      justify-content: flex-end !important;
      margin-left: auto !important;
    }
    
    .v-note-op-icon {
      margin: 0 1px !important;
      flex-shrink: 0 !important;
    }
    
    .v-note-op-btn {
      margin: 0 1px !important;
      padding: 2px 4px !important;
      flex-shrink: 0 !important;
      font-size: 12px !important;
    }
  }
}

// 全局复盘编辑器样式优化
.global-replay-editor {
  :deep(.v-note-op) {
    display: flex !important;
    flex-wrap: nowrap !important;
    overflow-x: auto !important;
    
    .v-left-item {
      flex: 1 !important;
      max-width: 92% !important;
      min-width: 0 !important;
      display: flex !important;
      flex-wrap: wrap !important;
    }
    
    .v-right-item {
      flex: 0 0 auto !important;
      max-width: 8% !important;
      min-width: fit-content !important;
      display: flex !important;
      flex-wrap: wrap !important;
      justify-content: flex-end !important;
      margin-left: auto !important;
    }
    
    .v-note-op-icon {
      margin: 0 1px !important;
      flex-shrink: 0 !important;
    }
    
    .v-note-op-btn {
      margin: 0 1px !important;
      padding: 2px 4px !important;
      flex-shrink: 0 !important;
      font-size: 12px !important;
    }
  }
}

// 题目复盘编辑器样式优化
.question-replay-editor {
  :deep(.v-note-op) {
    display: flex !important;
    flex-wrap: nowrap !important;
    overflow-x: auto !important;
    
    .v-left-item {
      flex: 1 !important;
      max-width: 92% !important;
      min-width: 0 !important;
      display: flex !important;
      flex-wrap: wrap !important;
    }
    
    .v-right-item {
      flex: 0 0 auto !important;
      max-width: 8% !important;
      min-width: fit-content !important;
      display: flex !important;
      flex-wrap: wrap !important;
      justify-content: flex-end !important;
      margin-left: auto !important;
    }
    
    .v-note-op-icon {
      margin: 0 1px !important;
      flex-shrink: 0 !important;
    }
    
    .v-note-op-btn {
      margin: 0 1px !important;
      padding: 2px 4px !important;
      flex-shrink: 0 !important;
      font-size: 12px !important;
    }
  }
}
</style> 

<style lang="scss">
// 全局样式（不使用 scoped），确保能应用到 el-dialog
.el-dialog__wrapper .replay-nav-dialog {
  width: 80% !important;
  max-width: 1300px !important;
  margin: 5vh auto 0 !important;
}

.replay-nav-dialog {
  .el-dialog {
    margin-top: 5vh !important;
    max-height: 90vh !important;
    height: 90vh !important;
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
  }
  
  .el-dialog__header {
    flex-shrink: 0 !important;
    padding: 15px 20px !important;
    border-bottom: 1px solid #ebeef5 !important;
  }
  
  .el-dialog__body {
    flex: 1 !important;
    overflow: auto !important;
    padding: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    min-height: 0 !important;
  }
  
  .el-dialog__footer {
    flex-shrink: 0 !important;
    padding: 15px 20px !important;
    border-top: 1px solid #ebeef5 !important;
  }
  
  // 固定的赛事信息区域 - 紫色渐变背景
  .fixed-game-info {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    padding: 14px 20px !important;
    border-bottom: 2px solid #5a67d8 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 20px !important;
    flex-shrink: 0 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
    
    .info-value {
      color: #ffffff !important;
      font-size: 16px !important;
      font-weight: 600 !important;
    }
    
    .separator {
      color: rgba(255, 255, 255, 0.6) !important;
      font-size: 16px !important;
      font-weight: 300 !important;
    }
  }
  
  // 导航+内容区域
  .replay-content-wrapper {
    flex: 1 !important;
    display: flex !important;
    flex-direction: row !important;
    overflow: hidden !important;
    min-height: 0 !important;
  }
  
  // 左侧导航
  .replay-nav {
    flex-shrink: 0 !important;
    width: 150px !important;
    background: linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%) !important;
    border-right: 1px solid #dee2e6 !important;
    overflow-y: auto !important;
    padding: 12px 8px !important;
    
    .nav-item {
      padding: 12px 14px !important;
      margin-bottom: 6px !important;
      cursor: pointer !important;
      display: flex !important;
      align-items: center !important;
      gap: 10px !important;
      transition: all 0.25s ease !important;
      border-radius: 6px !important;
      
      .nav-icon {
        font-size: 16px !important;
      }
      
      .nav-label {
        font-size: 14px !important;
        font-weight: 500 !important;
      }
      
      // 未完成
      &.incomplete {
        color: #6c757d !important;
        background-color: transparent !important;
        
        .nav-icon {
          color: #adb5bd !important;
        }
        
        &:hover {
          background-color: rgba(255, 255, 255, 0.7) !important;
        }
      }
      
      // 已完成
      &.completed {
        color: #28a745 !important;
        background-color: transparent !important;
        
        .nav-icon {
          color: #28a745 !important;
        }
      }
      
      // 激活
      &.active {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
        color: #ffffff !important;
        font-weight: 600 !important;
        box-shadow: 0 3px 8px rgba(102, 126, 234, 0.3) !important;
        
        .nav-icon {
          color: #ffffff !important;
        }
      }
    }
  }
  
  // 右侧编辑区域
  .replay-editor-area {
    flex: 1 !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    padding: 24px !important;
    background-color: #ffffff !important;
    min-width: 0 !important;
    
    .question-section {
      .question-header {
        margin-bottom: 24px !important;
        padding-bottom: 18px !important;
        border-bottom: 2px solid #ebeef5 !important;
        
        .info-line {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 10px 18px !important;
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%) !important;
          padding: 14px 18px !important;
          border-radius: 8px !important;
          border: 1px solid rgba(102, 126, 234, 0.15) !important;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04) !important;
          
          .seq {
            font-weight: 700 !important;
            color: #667eea !important;
            font-size: 16px !important;
            background: rgba(102, 126, 234, 0.15) !important;
            padding: 4px 10px !important;
            border-radius: 4px !important;
            margin-right: 0px !important;
          }
          
          .name {
            font-weight: 600 !important;
            color: #212529 !important;
            font-size: 15px !important;
          }
          
          .label {
            color: #6c757d !important;
            font-size: 13px !important;
            font-weight: 500 !important;
          }
          
          .value {
            font-weight: 600 !important;
            font-size: 14px !important;
          }
        }
      }
      
      // 题目选项区域（水平单行布局）
      .question-options {
        display: flex !important;
        flex-direction: row !important;
        align-items: center !important;
        gap: 12px !important;
        margin-bottom: 20px !important;
        flex-wrap: wrap !important;
        
        .option-label {
          display: flex !important;
          align-items: center !important;
          gap: 4px !important;
          white-space: nowrap !important;
          
          .label-text {
            font-size: 13px !important;
            font-weight: 600 !important;
            color: #495057 !important;
          }
          
          .required-mark {
            color: #f56c6c !important;
            font-size: 13px !important;
          }
        }
        
        .plan-display {
          display: flex !important;
          align-items: center !important;
          gap: 6px !important;
          
          .plan-label {
            color: #6c757d !important;
            font-size: 13px !important;
            font-weight: 500 !important;
            white-space: nowrap !important;
          }
        }
        
        .el-form-item {
          margin-bottom: 0 !important;
          
          .el-form-item__label {
            display: none !important;
          }
          
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
      }
    }
    
    // 全局复盘编辑器无label
    .global-replay {
      .el-form-item__label {
        display: none !important;
      }
      
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
  
  // 标签颜色定义（全局样式确保生效）
  .tags-inline {
    .el-tag.tag-color-1 { background-color: #409EFF !important; border-color: #409EFF !important; color: white !important; }
    .el-tag.tag-color-2 { background-color: #67C23A !important; border-color: #67C23A !important; color: white !important; }
    .el-tag.tag-color-3 { background-color: #E6A23C !important; border-color: #E6A23C !important; color: white !important; }
    .el-tag.tag-color-4 { background-color: #F56C6C !important; border-color: #F56C6C !important; color: white !important; }
    .el-tag.tag-color-5 { background-color: #8E44AD !important; border-color: #8E44AD !important; color: white !important; }
    .el-tag.tag-color-6 { background-color: #16A085 !important; border-color: #16A085 !important; color: white !important; }
    .el-tag.tag-color-7 { background-color: #D35400 !important; border-color: #D35400 !important; color: white !important; }
    .el-tag.tag-color-8 { background-color: #2980B9 !important; border-color: #2980B9 !important; color: white !important; }
    .el-tag.tag-color-9 { background-color: #27AE60 !important; border-color: #27AE60 !important; color: white !important; }
    .el-tag.tag-color-10 { background-color: #C0392B !important; border-color: #C0392B !important; color: white !important; }
    
    .el-tag.solid-tag {
      margin-right: 5px !important;
      margin-bottom: 0px !important;
      height: 28px !important;
      line-height: 26px !important;
      border: none !important;
      color: white !important;
    }
  }
  
  // 标签颜色样式（全局）
  .tags-inline .el-tag.tag-color-1,
  .el-tag.tag-color-1.solid-tag { background-color: #409EFF !important; border-color: #409EFF !important; color: white !important; }
  .tags-inline .el-tag.tag-color-2,
  .el-tag.tag-color-2.solid-tag { background-color: #67C23A !important; border-color: #67C23A !important; color: white !important; }
  .tags-inline .el-tag.tag-color-3,
  .el-tag.tag-color-3.solid-tag { background-color: #E6A23C !important; border-color: #E6A23C !important; color: white !important; }
  .tags-inline .el-tag.tag-color-4,
  .el-tag.tag-color-4.solid-tag { background-color: #F56C6C !important; border-color: #F56C6C !important; color: white !important; }
  .tags-inline .el-tag.tag-color-5,
  .el-tag.tag-color-5.solid-tag { background-color: #8E44AD !important; border-color: #8E44AD !important; color: white !important; }
  .tags-inline .el-tag.tag-color-6,
  .el-tag.tag-color-6.solid-tag { background-color: #16A085 !important; border-color: #16A085 !important; color: white !important; }
  .tags-inline .el-tag.tag-color-7,
  .el-tag.tag-color-7.solid-tag { background-color: #D35400 !important; border-color: #D35400 !important; color: white !important; }
  .tags-inline .el-tag.tag-color-8,
  .el-tag.tag-color-8.solid-tag { background-color: #2980B9 !important; border-color: #2980B9 !important; color: white !important; }
  .tags-inline .el-tag.tag-color-9,
  .el-tag.tag-color-9.solid-tag { background-color: #27AE60 !important; border-color: #27AE60 !important; color: white !important; }
  .tags-inline .el-tag.tag-color-10,
  .el-tag.tag-color-10.solid-tag { background-color: #C0392B !important; border-color: #C0392B !important; color: white !important; }
  
  .tags-inline .el-tag.solid-tag,
  .el-tag.solid-tag {
    margin-right: 5px !important;
    margin-bottom: 0px !important;
    height: 28px !important;
    line-height: 26px !important;
    border: none !important;
    color: white !important;
  }
  
  // 强制设置编辑和显示区域的padding
  .game-replay-dialog .global-replay,
  .game-replay-dialog .question-section {
    .v-note-wrapper .v-note-panel {
      .v-note-edit .content-input-wrapper {
        padding: 12px !important;
      }
      
      .v-note-show {
        padding: 12px !important;
        
        .v-show-content p {
          margin: 0 0 8px 0 !important;
        }
      }
    }
  }
}
</style>
 
 